import { SEO } from '../components/SEO';
import { companyInfo } from '../data/content';

export function Impressum() {
  return (
    <>
      <SEO 
        title="Impressum"
        description="Impressum von ConciergeUnit - Rechtliche Informationen und Kontaktdaten."
        path="/impressum"
      />

      <section className="pt-32 pb-20 bg-brand-950">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">Impressum</h1>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              
              <div className="bg-platin-50 rounded-xl p-6 mb-8 border-l-4 border-brand-950">
                <p className="font-semibold text-brand-950">{companyInfo.name}</p>
                <p className="text-gray-700">Inhaber: {companyInfo.owner}</p>
                
                <div className="mt-4 text-gray-700">
                  <p>{companyInfo.address.street}</p>
                  <p>{companyInfo.address.zip} {companyInfo.address.city}</p>
                  <p>{companyInfo.address.country}</p>
                </div>

                <div className="mt-4 space-y-1">
                  <p>
                    <strong>Telefon:</strong>{' '}
                    <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-brand-600 hover:underline">
                      {companyInfo.phone}
                    </a>
                  </p>
                  <p>
                    <strong>E-Mail:</strong>{' '}
                    <a href={`mailto:${companyInfo.email}`} className="text-brand-600 hover:underline">
                      {companyInfo.email}
                    </a>
                  </p>
                </div>

                {companyInfo.vatId && (
                  <p className="mt-4">
                    <strong>USt-IdNr.:</strong> {companyInfo.vatId}
                  </p>
                )}

                {companyInfo.registration && (
                  <p className="mt-4">
                    <strong>Handelsregister:</strong> {companyInfo.registration}
                  </p>
                )}
              </div>

              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Vertreten durch
              </h2>
              <p className="text-gray-700 mb-8">
                {companyInfo.owner}, Inhaber
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <div className="bg-platin-50 rounded-xl p-6 mb-8">
                <p className="text-gray-700">{companyInfo.owner}</p>
                <p className="text-gray-600 mt-2">{companyInfo.address.street}</p>
                <p className="text-gray-600">{companyInfo.address.zip} {companyInfo.address.city}</p>
              </div>

              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Hinweis zur Streitbeilegung
              </h2>
              <p className="text-gray-700 mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-brand-600 hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="text-gray-700 mb-8">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Haftung für Inhalte
              </h2>
              <p className="text-gray-700 mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>
              <p className="text-gray-700 mb-8">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Haftung für Links
              </h2>
              <p className="text-gray-700 mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                Seiten verantwortlich.
              </p>
              <p className="text-gray-700 mb-8">
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße 
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. 
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4">
                Urheberrecht
              </h2>
              <p className="text-gray-700 mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
              <p className="text-gray-700 mb-8">
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch 
                gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden 
                die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
                gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
                bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden 
                wir derartige Inhalte umgehend entfernen.
              </p>

              <p className="text-sm text-gray-500 mt-12">
                Stand: Februar 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
